import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                top: 'top'
            }
        }
    }

    init() {
        this.result = this.el.querySelector('.c-stopwatch_result');
        this.startTime = null;
        this.interval = null;
    }

    start() {
        this.el.classList.add('-visible');
        this.startTime = Date.now();
        this.interval = setInterval(this.update.bind(this), 10);
    }

    update() {
        const currentTime = Date.now();
        let elapsedTime = currentTime - this.startTime;

        let minutes = Math.floor(elapsedTime / (1000 * 60) % 60);
        let seconds = Math.floor(elapsedTime / 1000 % 60);
        let milliseconds = Math.floor(elapsedTime % 1000 / 100); // /10 to have 2 digits for ms 

        minutes = String(minutes).padStart(2, '0');
        seconds = String(seconds).padStart(2, '0');
        // milliseconds = String(milliseconds).padStart(2, '0');
        
        this.result.innerHTML = minutes + ':' + seconds + '.' + milliseconds;
    }

    top(e){
        e.preventDefault();
        document.querySelector('.c-stopwatch_vhs').classList.add('-visible');
        this.call('scrollVHS', 'Scroll');
        setTimeout(() => {
            document.querySelector('.c-stopwatch_vhs').classList.remove('-visible');
        }, 2000);
    }
}